module.exports = __webpack_public_path__ + "startpage-746fed5a/google-play-badge-de-5ade2d6002317f2493eec0113fa58b28.png";